"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./CheckboxField.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Checkbox field
    
    A checkbox field

    Verified by: Yorben Verhoest
    Date: 06/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Our main component
var CheckboxField = function CheckboxField(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkBox ".concat(props.name ? props.name : '', " ").concat(props.className ? props.className : '', " ").concat(props.checked ? 'active' : '', " ").concat(props.disabled ? 'disabled' : '', " ").concat(props.position)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "checkBox".concat(props.name ? props.name : '')
  }, props.position === 'right' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, props.value), /*#__PURE__*/_react["default"].createElement("input", {
    checked: props.checked,
    disabled: props.disabled,
    id: "checkBox".concat(props.name ? props.name : ''),
    name: props.name,
    type: "checkbox",
    "aria-label": props.label,
    onChange: function onChange(e) {
      return props.onChange ? props.onChange(e.target.checked) : undefined;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxBox ".concat(props.value ? 'active' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxBoxSelected"
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    checked: props.checked,
    disabled: props.disabled,
    id: "checkBox".concat(props.name ? props.name : ''),
    name: props.name,
    type: "checkbox",
    "aria-label": props.label,
    onChange: function onChange(e) {
      return props.onChange ? props.onChange(e.target.checked) : undefined;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxBox ".concat(props.value ? 'active' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxBoxSelected"
  })), /*#__PURE__*/_react["default"].createElement("span", null, props.value))));
};

var _default = CheckboxField;
exports["default"] = _default;